import React, { Component } from 'react'; 
import ImageGallery from 'react-image-gallery';
import "../image-gallery.css";
import * as config from '../config';
import Modal from 'react-modal';
 
class ImageView extends Component {
  constructor () {
    super();
    this.state = {
      showModal: false,
      imgurl:""
    };
    
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleOpenModal () {
    this.setState({ showModal: true });
  }
  
  handleCloseModal () {
    this.setState({ showModal: false });
  } 
  componentWillMount(){ 
    Modal.setAppElement('body');
  }
  onClick=(event)=>{
    console.dir(event.target.src);
       this.setState({ showModal: true,imgurl: event.target.src});
    setTimeout(()=>{
      window.wheelzoom(document.querySelectorAll('.img-modal')); 
    },500)
       
  }
  render() {
    
    let images =[];
    for(let i=0;i<this.props.files.length;i++){
      images.push({
        original:  config.URL_WEBSERVICE+"/api/files/"+this.props.files[i].duongdan, 
        thumbnail:  config.URL_WEBSERVICE+"/api/files/"+this.props.files[i].duongdan, 
      });
    }

    const model_img={
      maxWidth:"100%", 
    }
    const customStyles = {
      content : {
        top                   : '50%',
        left                  : '50%',
        right                 : 'auto',
        bottom                : 'auto',
        marginRight           : '-50%',
        transform             : 'translate(-50%, -50%)'
      }
    };
   
    return (
      <div>
        <div className="ct-pr">
          <ImageGallery
            items={images} 
            //thumbnailPosition={isMobile?'bottom':'left'}
            thumbnailPosition={'bottom'}
            onClick={this.onClick}
            showNav={false}
            showPlayButton={false}
            showFullscreenButton ={false}
           // onThumbnailClick={this.onClick}
            //showFullscreenButton={this.props.files.length>0?true:false}
        />
      </div>

        <Modal 
           isOpen={this.state.showModal}
           style={customStyles}
        >
         <div className="container">
          <div className="row">
              <div className="col-md-12" style={{paddingRight: "0px !important",paddingBottom:"15px",marginBottom:"5px",borderBottom:"1px solid #ccc"}}>
              <button type="button" className="close" title={"Đóng chức năng xem ảnh"} onClick={this.handleCloseModal} style={{float:'right'}}>
          <span aria-hidden="true">&times;</span>
        </button>
              </div>
            </div>
            <div className="row">
            <div className="col-md-12" style={{maxHeight: "80vh", overflow: "auto",paddingTop:"5px"}}>
            <img src={this.state.imgurl} className={"img-modal"} style={model_img} alt="hinh" />
            </div>
            </div>
          </div>
            
        </Modal>
      </div>
      
      
    );
  }
}
 
export default ImageView;